import { Box, Icon, SpaceBetween } from '@amzn/awsui-components-react';
import React from 'react';
import { IconProps } from '../../common/types';

export const DurationIcon = ({ value, size = 'small' }: IconProps) => {
    return (
        <SpaceBetween size={size == 'small' ? 'xxs' : 'xs'} direction='horizontal'>
            <Icon
                name='calendar'
                variant={size == 'small' ? 'subtle' : 'normal'}
                size={size == 'small' ? 'small' : 'medium'}
                alt='Duration'
                data-testid='duration'
            />
            <Box
                color={size == 'small' ? 'text-status-inactive' : 'inherit'}
                variant='div'
                fontSize={size == 'small' ? 'heading-xs' : 'heading-m'}
                fontWeight={size == 'small' ? 'normal' : 'bold'}
            >
                <h3>{value}</h3>
            </Box>
        </SpaceBetween>
    );
};
